import { IUserState } from '../types/user';
import { TApplicationState } from '../types/redux';

export const getUserId = (state: TApplicationState): IUserState['userId'] => state.user.userId;

export const getUserPhone = (state: TApplicationState): IUserState['phoneNumber'] => state.user.phoneNumber;
